import React from "react";
import { component_tool } from "@/tool";
import { WizTableForm } from '@/containers/common';
import moment from "moment";
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY.MM.DD HH.mm.ss') : '';
}
//配置项
const componentName = "classStudentManagement";
let ref;
const _columns =(isAttendTitle) =>{
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      searchItem: {},
      tableItem: {
        width: 120,
      },
      formItem: {}
    },
    {
      title: "账号",
      name: "userName",
      dataIndex: "userName",
      searchItem: {},
      tableItem: {
        width: 120,
      },
      formItem: {}
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {
        width: 120,
      }
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig,
      }
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      }
    },

    {
      title: "组织名称",
      name: "orgName",
      tableItem: {
        width: 180,
      }
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {
        width: 100,
      }
    },
    {
      title: "任职状态",
      name: "jobState",
      dict: [
        {code: 0, codeName: '离职'},
        {code: 1, codeName: '在职'},
      ],
      tableItem: {
        width: 100,
      },
    },
    {
      title: "是否请假",
      name: "leaveState",
      dict: [
        {code: 0, codeName: "否"},
        {code: 1, codeName: "是"}
      ],
      tableItem: {
        width: 100,
      },
      searchItem: {
        type: 'select'
      }
    },
    {
      title: '是否'+isAttendTitle,
      name: 'isAttend',
      tableItem: {
        width: 100,
      },
      dict: [
        { code: 0, codeName: "未"+isAttendTitle },
        { code: 1, codeName: "已"+isAttendTitle }
      ],
      formItem: {
        type: "radio",
        initialValue: 0
      },
      searchItem: {
        type: 'select'
      }
    },
    {
      title: "进入时间",
      name: "startTime",
      tableItem: {
        width: 100,
        render: (text, record) => {
          return formatterDateTime(text)
        }
      },
    },
    {
      title: "离开时间",
      name: "endTime",
      tableItem: {
        width: 100,
        render: (text, record) => {
          return formatterDateTime(text)
        }
      },
    },
    {
      title: "累计观看时长(分钟)",
      name: "duration",
      tableItem: {
        width: 150,
        render: (text, record) => {
          return text ? text : ''
        }
      },
    },
    {
      title: "累计进入次数",
      name: "countNumber",
      tableItem: {
        width: 150,
      }
    },
  ];
}

const templateConfig = (date) => {
  const {onSelect,classInfoId ,entityId,classAideId,aideTypeId,_btnLookUserFun,_this,aideTypeName} = date;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows)
  };
  let titleName = '记录';
  let isAttendTitle = '参加';
  if (aideTypeName==='直播课堂'){
    titleName='参训记录';
    isAttendTitle = '参训';
  }else if (aideTypeName==='远程评估'){
    titleName='评估记录';
    isAttendTitle = '参加';
  }
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns:_columns(isAttendTitle),
        btnAccessCheck:false,
        searchBarProps: {
          buttonSort: ['export','syncLiveRecord'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出'+titleName, type:'primary'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportClassStudentInteractLive",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: "syncLiveRecord",
              custom: true,
              params: { icon: 'reload', children: '同步'+titleName, type: 'reload'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "syncLiveRecord",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
          onSelect: _onSelect
        },
        commonOperate: {
          update: false
        },
        rowOperateSort: [],
        rowOperateView: [ ]
      }
    }
  }
};



let reduxTemplateCofig = args => {
  const { classInfoId ,entityId,classAideId,aideTypeId} = args;
  const apis = {
    list: {
      path: `${componentName}/interactLiveByPage`,
      payload: {
        key: `${componentName}@interactLiveByPage`,
        apiParams: { classInfoId: classInfoId,entityId: entityId,classAideId:classAideId,aideTypeId:aideTypeId}
      }
    },
    exportClassStudentInteractLive: {
      path: `${componentName}/interactLiveByList`,
      payload: {
        key: `${componentName}@interactLiveByList`,
        apiParams: { classInfoId: classInfoId,entityId: entityId,classAideId:classAideId,aideTypeId:aideTypeId}
      }
    },

    syncLiveRecord: {
      path: `${componentName}/syncLiveRecord`,
      payload: {
        key: `${componentName}@syncLiveRecord`,
        apiParams: {id : entityId}
      }
    }
  };

  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    keepInitApiParams: true,
    needLoading: false,
    ...args
  };
};

export { reduxTemplateCofig, templateConfig };
